import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
        lng: localStorage.getItem('cft-language')?.toString(),
        backend: {
            loadPath: `${process.env.PUBLIC_URL}/i18n/{{lng}}.json`
        },
        fallbackLng: 'vi',
        debug: false,
        defaultNS: 'translations',
        keySeparator: false,
        interpolation: {
            escapeValue: false,
            formatSeparator: ','
        },
        react: {
            useSuspense: false
        }
    });

export default i18n;
